<template >
    <div >
<script :id="editorID" type="text/plain">
</script>
    </div>
</template>
<script>
    export default {
        name: 'UE',
        data() {
            return {
                editor: null,
                editorID:'editor',
            }
        },
        props:  ['defaultMsg','config','contentChange','UE'],
        mounted() {
            var  timestamp=new Date().getTime()
            this.editorID = 'editor'+timestamp;
            const _this = this;

            window.setTimeout(function(){
                _this.editor = window.UE.getEditor(_this.editorID, this.config); // 初始化UE
                _this.editor.addListener("ready", function() {
                    _this.editor.setContent(_this.defaultMsg?_this.defaultMsg:''); // 确保UE加载完成后，放入内容。
                });

                if( _this.UE){
                    _this.UE.editor = _this.editor;
                }
                _this.editor.addListener("contentChange", function() {
                    if (_this.contentChange) {
                        _this.contentChange(_this.getUEContent());
                    }
                });
            },500)


        },
        methods: {
            getUEContent() { // 获取内容方法
                return this.editor.getContent()
            }
        },
        destroyed() {
            this.editor.destroy();
        },
        watch:{
            defaultMsg (){
                if(this.getUEContent()!=this.defaultMsg){
                    this.editor.setContent(this.defaultMsg?this.defaultMsg:'');
                }
            }
        }
    }


</script>


<style>
.edui-editor{
    line-height: 25px;
}
</style>




// WEBPACK FOOTER //
// UE.vue?8f7959d4